import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { IAuthorizationProps } from './authorization-props';
import { hasFeatures } from './features';
import { Navigation } from '../../global-functions';

const withFeature =
    (features: string[]) =>
    <P extends object>(WrappedComponent: React.ComponentType<P>) => {
        const Wrapper = ({ session, ...rest }: IAuthorizationProps) => {
            let children;

            if (hasFeatures(session, features)) {
                children = <WrappedComponent {...(rest as P)} />;
            } else {
                Navigation.pushExternal('/');
            }

            return <>{children}</>;
        };

        const mapStateToProps = (state: RootState) => ({
            session: state.session!.data!,
        });

        return connect(mapStateToProps)(Wrapper);
    };

export default withFeature;
